"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let MeterConsumption = class MeterConsumption extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    getPayload(...args) {
        const item = this.item;
        return _.extend(item, {
            meter: { id: item.meter.id },
            unit_price: (item.unit_price && item.unit_price.amount != null) ? item.unit_price : null,
        });
    }
    oid;
    onOid(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("oid");
    }
    meter;
    onMeter(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("meter");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    item;
    async $$load_item() {
        return this.oid
            ? this.$fn.fetch('read_meter_consumption', { parameters: { id: this.oid } }).then(p => {
                if (p.unit_price == null) {
                    p.unit_price = { amount: null, currency: null };
                }
                return p;
            })
            : this.$fn.schemaDefaults('CreateMeterConsumption', {
                meter: this.meter || {},
                unit: this.meter ? this.meter.unit : null,
                unit_price: { amount: null, currency: null }
            });
    }
    currencies;
    async $$load_currencies() {
        return this.$fn.fetch('list_currency');
    }
    units;
    async $$load_units() {
        return this.$fn.fetch('list_unit').then(d => _.orderBy(d, [p => p.symbol.toLowerCase()]));
    }
    formName;
    formId;
    async $$load_formId() {
        return this.$fn.randomElementId();
    }
    labelAlign;
    isReadOnly;
    async $$load_isReadOnly() {
        return this.item.locked || this.item.isReadonly;
    }
    tariffs;
    async $$load_tariffs() {
        return this.$app.repo.get('list_object_by_type', { parameters: { object_type: 'tariff' } });
    }
    ux;
    b_7315092382398562_modalBindings;
    b_4152404563918957_dataSource;
    dataMembers = ['item', 'currencies', 'units', 'formName', 'formId', 'labelAlign', 'isReadOnly', 'tariffs', 'ux', 'b_7315092382398562_modalBindings', 'b_4152404563918957_dataSource'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                item: null,
                currencies: null,
                units: null,
                formName: "meterConsumption",
                formId: null,
                labelAlign: "right",
                isReadOnly: null,
                tariffs: null,
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "md",
                },
                b_4152404563918957_dataSource: {
                    name: "suggest_rental",
                },
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.oid ? this.$fn.gettext('Edit Meter Consumption') : this.$fn.gettext('Add Meter Consumption'),
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_9250_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async act_1040167445267876_closeModal_9256_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                ok: true,
                value: $event.data.response.data,
            },
        };
    }
    async act_1040167445267876_request_9254_getActionArgs($event) {
        return {
            operation: this.item.id ? 'update_meter_consumption' : 'create_meter_consumption',
            data: this.getPayload(),
        };
    }
    async evh_1040167445267876_submit(event, scope) {
        return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
    }
    async act_7789867021953041_setData_9258_getActionArgs($event) {
        return {
            path: "item.unit",
            value: $event.data.unit,
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async evh_7789867021953041_optionSelected(event, scope) {
        return await this.actions.evh_7789867021953041_optionSelected.executeFromDOM(this, event, scope);
    }
    async act_2140198529698299_closeModal_9260_getActionArgs($event) {
        return {
            result: {
                ok: true,
            },
        };
    }
    async evh_2140198529698299_success(event, scope) {
        return await this.actions.evh_2140198529698299_success.executeFromDOM(this, event, scope);
    }
    async act_2434514588044777_closeModal_9262_getActionArgs($event) {
        return {
            result: {
                ok: true,
            },
        };
    }
    async evh_2434514588044777_success(event, scope) {
        return await this.actions.evh_2434514588044777_success.executeFromDOM(this, event, scope);
    }
    async act_2186679009640457_closeModal_9264_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                cancel: true,
            },
        };
    }
    async evh_2186679009640457_clickPreventStop(event, scope) {
        return await this.actions.evh_2186679009640457_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_9250 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_9250_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_9249 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_9250,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_9249],
        });
        const act_2248226175642056_closeComponent_9252 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_2248226175642056_close_9251 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeComponent_9252,
            event: "close",
            displayName: "closeComponent",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_9251],
        });
        const act_1040167445267876_closeModal_9256 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_1040167445267876_closeModal_9256_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_success_9255 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_closeModal_9256,
            event: "success",
            displayName: "closeModal",
        });
        const act_1040167445267876_request_9254 = new core_1.actions.RequestAction({
            actionArgs: this.act_1040167445267876_request_9254_getActionArgs,
            displayName: "submit",
            events: [evh_1040167445267876_success_9255],
        });
        const evh_1040167445267876_submit_9253 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_request_9254,
            event: "submit",
            displayName: "submit",
        });
        const evh_1040167445267876_submit = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1040167445267876_submit_9253],
        });
        const act_7789867021953041_setData_9258 = new core_1.actions.SetDataAction({
            actionArgs: this.act_7789867021953041_setData_9258_getActionArgs,
            events: [],
        });
        const evh_7789867021953041_optionSelected_9257 = new core_1.actions.EventHandlerImpl({
            action: act_7789867021953041_setData_9258,
            event: "optionSelected",
            displayName: "setData",
        });
        const evh_7789867021953041_optionSelected = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7789867021953041_optionSelected_9257],
        });
        const act_2140198529698299_closeModal_9260 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_2140198529698299_closeModal_9260_getActionArgs,
            events: [],
        });
        const evh_2140198529698299_success_9259 = new core_1.actions.EventHandlerImpl({
            action: act_2140198529698299_closeModal_9260,
            event: "success",
            displayName: "closeModal",
        });
        const evh_2140198529698299_success = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2140198529698299_success_9259],
        });
        const act_2434514588044777_closeModal_9262 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_2434514588044777_closeModal_9262_getActionArgs,
            events: [],
        });
        const evh_2434514588044777_success_9261 = new core_1.actions.EventHandlerImpl({
            action: act_2434514588044777_closeModal_9262,
            event: "success",
            displayName: "closeModal",
        });
        const evh_2434514588044777_success = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2434514588044777_success_9261],
        });
        const act_2186679009640457_closeModal_9264 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_2186679009640457_closeModal_9264_getActionArgs,
            events: [],
        });
        const evh_2186679009640457_clickPreventStop_9263 = new core_1.actions.EventHandlerImpl({
            action: act_2186679009640457_closeModal_9264,
            event: "click.prevent.stop",
            displayName: "closeModal",
        });
        const evh_2186679009640457_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2186679009640457_clickPreventStop_9263],
        });
        return {
            act_7315092382398562_closeModal_9250,
            evh_7315092382398562_close_9249,
            evh_7315092382398562_close,
            act_2248226175642056_closeComponent_9252,
            evh_2248226175642056_close_9251,
            evh_2248226175642056_close,
            act_1040167445267876_closeModal_9256,
            evh_1040167445267876_success_9255,
            act_1040167445267876_request_9254,
            evh_1040167445267876_submit_9253,
            evh_1040167445267876_submit,
            act_7789867021953041_setData_9258,
            evh_7789867021953041_optionSelected_9257,
            evh_7789867021953041_optionSelected,
            act_2140198529698299_closeModal_9260,
            evh_2140198529698299_success_9259,
            evh_2140198529698299_success,
            act_2434514588044777_closeModal_9262,
            evh_2434514588044777_success_9261,
            evh_2434514588044777_success,
            act_2186679009640457_closeModal_9264,
            evh_2186679009640457_clickPreventStop_9263,
            evh_2186679009640457_clickPreventStop,
            submit: act_1040167445267876_request_9254,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: null,
    }),
    __metadata("design:type", String)
], MeterConsumption.prototype, "oid", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('oid'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], MeterConsumption.prototype, "onOid", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Object,
        default: null,
    }),
    __metadata("design:type", Object)
], MeterConsumption.prototype, "meter", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('meter'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], MeterConsumption.prototype, "onMeter", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "md",
    }),
    __metadata("design:type", String)
], MeterConsumption.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], MeterConsumption.prototype, "onSize", null);
MeterConsumption = __decorate([
    (0, vue_property_decorator_1.Component)()
], MeterConsumption);
exports.default = MeterConsumption;
vue_property_decorator_1.Vue.component("MeterConsumption", MeterConsumption);
